import { SocietePatrimoineHierarchieAncetreState } from '@get/store/states';
import { Action, createReducer } from '@ngrx/store';
import { societePatrimoineHierarchieAncetreReducersGeneratedFunctions } from './societe-patrimoine-hierarchie-ancetre-generated.reducer';

const societePatrimoineHierarchieAncetreReducersFunctions = [
  ...societePatrimoineHierarchieAncetreReducersGeneratedFunctions
];

const societePatrimoineHierarchieAncetreReducer = createReducer(
  SocietePatrimoineHierarchieAncetreState.initialState,
  ...societePatrimoineHierarchieAncetreReducersFunctions
);

export function reducer(state: SocietePatrimoineHierarchieAncetreState.IState | undefined, action: Action) {
  return societePatrimoineHierarchieAncetreReducer(state, action);
}
